import React, { useState, useEffect } from "react";
import { FaCheckCircle, FaCircle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import Footer from "./Footer";
import { useDropzone } from "react-dropzone";
import apiClient from "../components/apiClient";
import Navbar from "../components/Navbar";
import Clock from "../assets/Clock.png";

// function Checkout() {
const PaymentPage = () => {
  const [cart, setCart] = useState([]);
  const [addresses, setAddresses] = useState([]);
  const [cartLoading, setCartLoading] = useState(true);
  const [addressLoading, setAddressLoading] = useState(true);
  const [isAddressSelected, setIsAddressSelected] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [currentStep, setCurrentStep] = useState(1);
  const [completedSteps, setCompletedSteps] = useState([
    false,
    false,
    false,
    false,
    false,
  ]);

  const [courier, setCourier] = useState(null);
  const [origin, setOrigin] = useState(null);
  const [shippingOptions, setShippingOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [totalWeight, setTotalWeight] = useState(0);

  const [profile, setProfile] = useState();
  const [orders, setOrders] = useState([]);

  const [isEditPopupVisible, setIsEditPopupVisible] = useState(false);
  const [addressToEdit, setAddressToEdit] = useState({
    namapenerima: "",
    nomerteleponpenerima: "",
  });

  const handleAddressSelects = () => {
    setIsAddressSelected(true);
  };

  // useEffect(() => {
  //   const sendCallbackAndReminder = async () => {
  //     const urlParams = new URLSearchParams(window.location.search);
  //     const userid = localStorage.getItem("userId");
  //     const token = localStorage.getItem("token");
  //     const email = localStorage.getItem("email");
  //     const products = JSON.parse(localStorage.getItem("products") || "[]");
  //     const snapUrl = localStorage.getItem("snapUrl"); // optional, only for pending
  //     const orderid = urlParams.get("order_id");
  //     const transaction_status = urlParams.get("transaction_status");
  //     const status_code = urlParams.get("status_code");
  //     const payment_type = localStorage.getItem("paymentType");

  //     if (!orderid || !transaction_status || !token || !userid || !email) {
  //       console.warn("Missing required data for callback or reminder.");
  //       return;
  //     }

  //     const payload = {
  //       userid,
  //       order_id: orderid,
  //       transaction_status,
  //       status_code,
  //       payment_type,
  //     };

  //     try {
  //       // Send Midtrans callback to backend
  //       const { data: callbackData } = await apiClient.post(
  //         "/order/payment/callback",
  //         payload,
  //         {
  //           headers: {
  //             Authorization: `Bearer ${token}`,
  //           },
  //         }
  //       );
  //       console.log("Callback response:", callbackData);

  //       // Delay slightly to ensure order status updates in DB
  //       setTimeout(async () => {
  //         try {
  //           await apiClient.post("/order/reminder-va", {
  //             email,
  //             orderid,
  //             products,
  //             userId: userid,
  //             snapUrl,
  //           });
  //           console.log("Reminder email sent.");
  //         } catch (reminderErr) {
  //           console.error("Error sending reminder email:", reminderErr);
  //         }
  //       }, 1500); // 1.5 seconds wait time to ensure DB updated
  //     } catch (error) {
  //       console.error("Error during callback or reminder:", error);
  //     }
  //   };

  //   sendCallbackAndReminder();
  // }, []);

  useEffect(() => {
    const totalCartWeight = cart.reduce((acc, item) => {
      const product = item.Produk || item.produk;
      return acc + product.berat * item.jumlah; // Multiply weight by quantity
    }, 0);
    setTotalWeight(totalCartWeight); // Update total weight
  }, [cart]);

  //origin
  useEffect(() => {
    const fetchOrigin = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/origin`
        );
        const data = await response.json();
        console.log("Origin API Response:", data); // Debugging response
        if (data && data[0] && data[0].kotaId) {
          setOrigin(data[0].kotaId); // Use kotaId from the response
        } else {
          console.error("No origin city ID found in the response.");
        }
      } catch (error) {
        console.error("Error fetching origin:", error);
      }
    };

    fetchOrigin();
  }, []); // This runs once when the component mounts

  //brand and cost
  // useEffect(() => {
  //   const fetchShippingCost = async () => {
  //     if (!origin || !selectedAddress) return; // Ensure origin and selectedAddress are available

  //     setLoading(true);
  //     try {
  //       fetch(`${process.env.REACT_APP_API_BASE_URL}/brand`);

  //       const response = await fetch(
  //         `${process.env.REACT_APP_API_BASE_URL}/cost`,
  //         {
  //           method: "POST",
  //           headers: {
  //             "Content-Type": "application/json",
  //           },
  //           body: JSON.stringify({
  //             origin: origin, // Use dynamic origin
  //             destination: selectedAddress.kotaId, // Use cityId from selectedAddress
  //             weight: totalWeight, // Use total weight calculated from cart
  //             courier: courier, // Selected courier
  //           }),
  //         }
  //       );

  //       const data = await response.json();
  //       console.log("Shipping Cost API Response:", data); // Debugging response
  //       if (data.rajaongkir?.results?.length > 0) {
  //         const costs = data.rajaongkir.results[0].costs;
  //         setShippingOptions(costs);
  //       } else {
  //         console.error("No shipping options found.");
  //         setShippingOptions([]); // Set to empty if no results found
  //       }
  //     } catch (error) {
  //       console.error("Error fetching shipping cost:", error);
  //       setShippingOptions([]);
  //     }
  //     setLoading(false);
  //   };

  //   if (totalWeight > 0 && origin && selectedAddress?.kotaId) {
  //     fetchShippingCost(); // Fetch shipping cost when total weight, origin, and selected address are available
  //   }
  // }, [totalWeight, courier, origin, selectedAddress]); // Re-fetch when total weight, courier, origin, or selectedAddress changes

  useEffect(() => {
    const storedOption = localStorage.getItem("selectedOption");
    console.log("Stored Option:", storedOption);
    if (storedOption) {
      setSelectedOption(JSON.parse(storedOption)); // Convert back to object
    }
  }, []);

  useEffect(() => {
    const courier = localStorage.getItem("selectedCourier");
    if (courier) {
      setCourier(courier);
    }
  });

  //alamat db
  useEffect(() => {
    const fetchAddresses = async () => {
      setAddressLoading(true);
      try {
        const token = localStorage.getItem("token");
        if (!token) throw new Error("Token not found");

        const addressResponse = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/alamat`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!addressResponse.ok) {
          throw new Error(
            `Address fetch failed with status: ${addressResponse.status}`
          );
        }

        const addresses = await addressResponse.json();
        setAddresses(addresses || []);
      } catch (error) {
        console.error("Failed to fetch addresses", error);
        setAddresses([]);
      } finally {
        setAddressLoading(false);
      }
    };

    // Retrieve the full cart data from localStorage
    const storedSelectedCartItems =
      JSON.parse(localStorage.getItem("selectedCartItems")) || [];
    console.log("Stored selected cart items:", storedSelectedCartItems); // Debug log
    setCart(storedSelectedCartItems); // Set cart state with full items (not just ids)

    //product
    // const fetchProductData = async () => {
    //   const productIds = storedSelectedCartItems.map((item) => item.produkId); // Extract produkId from cart items

    //   try {
    //     const response = await fetch(
    //       `${process.env.REACT_APP_API_BASE_URL}/produk/all`
    //     );
    //     if (!response.ok) {
    //       throw new Error(`Error fetching products: ${response.statusText}`);
    //     }

    //     const allProducts = await response.json();

    //     const selectedProducts = allProducts.filter((product) =>
    //       productIds.includes(product.id)
    //     );

    //     // Ensure all selected products have the `spesifikasi` field available
    //     setProducts(selectedProducts);
    //   } catch (error) {
    //     console.error("Failed to fetch products:", error);
    //     toast.error("Failed to fetch products. Please try again later.");
    //   }
    // };

    fetchAddresses();
    // fetchProductData();

    setCurrentStep(2);
    setCompletedSteps([true, false, false, false, false]);
  }, []);

  const formatRupiah = (angka) => {
    return new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
      minimumFractionDigits: 0,
    }).format(angka);
  };

  let colorsData = {};

  const fetchColors = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/color`
      );
      const data = await response.json();
      colorsData = data.colorList.reduce((acc, color) => {
        acc[color.color_hex.toLowerCase()] = color.color_name;
        return acc;
      }, {});
    } catch (error) {
      console.error("Failed to fetch colors:", error);
    }
  };

  // Fetch provinces

  fetchColors();

  const [accountNumber, setAccountNumber] = useState("");
  const [accountName, setAccountName] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);

  // Drag & Drop Logic
  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*,application/pdf",
    onDrop: (acceptedFiles) => {
      setSelectedFile(acceptedFiles[0]);
    },
  });

  //user praofile
  useEffect(() => {
    const fetchProfile = async () => {
      const token = localStorage.getItem("token");
      if (!token) {
        window.location.href = "/login"; // Redirect to login if token is missing
        return;
      }
      try {
        const response = await apiClient.get("/user/profile", {
          headers: { Authorization: `Bearer ${token}` },
        });
        setProfile(response.data); // ✅ make sure 'profile' state has 'nama'
      } catch (error) {
        console.error("Error fetching profile:", error);
      }
    };
    fetchProfile();
  }, []);

  //alamat db
  useEffect(() => {
    const fetchAddresses = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/alamat`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        if (response.ok) {
          const data = await response.json();
          setAddresses(data);
        } else {
          console.error("Failed to fetch addresses");
        }
      } catch (error) {
        console.error("Error fetching addresses:", error);
      }
    };

    fetchAddresses();
  }, []);

  useEffect(() => {
    const stored = localStorage.getItem("selectedAddress");
    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        setSelectedAddress(parsed);
      } catch (err) {
        console.error(
          "Failed to parse selectedAddress from localStorage:",
          err
        );
      }
    }
  }, []);

  const orderid = localStorage.getItem("orderId");
  console.log(orderid);
  //order db
  useEffect(() => {
    const fetchOrders = async () => {
      const orderId = localStorage.getItem("orderId"); // Get it inside useEffect
      console.log("Fetched orderId:", orderId);

      if (!orderId) {
        console.warn("No orderId found in localStorage.");
        return;
      }

      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/order/items/${orderId}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        if (response.ok) {
          const data = await response.json();
          setOrders(data);
        } else {
          console.error("Failed to fetch order items");
        }
      } catch (error) {
        console.error("Error fetching order items:", error);
      }
    };

    fetchOrders();
  }, []);

  const calculateTotal = (orders) => {
    return orders.reduce((total, item) => {
      const harga = parseFloat(item.harga_per_item) || 0;
      const jumlah = parseInt(item.jumlah, 10) || 0;
      const diskon = parseFloat(item.diskon) || 0;

      const hargaSetelahDiskon =
        diskon > 0 ? harga - (harga * diskon) / 100 : harga;

      const totalItem = hargaSetelahDiskon * jumlah;

      return total + totalItem;
    }, 0);
  };

  const totalPrice = calculateTotal(orders);
  console.log(totalPrice);

  // Get the first order if it exists
  const order = orders[0];

  const navigate = useNavigate();

  useEffect(() => {
    // Assume your main logic has finished at this point
    const timer = setTimeout(() => {
      localStorage.removeItem("selectedOption");
      navigate("/"); // redirect to main page
    }, 60000); // 60,000 ms = 1 minute

    // Cleanup timer if the component unmounts before 1 minute
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <Navbar />
      <div className="w-full mt-28 px-10 md:px-40 bg-gray-100 p-8">
        {/* <ToastContainer /> */}
        <div className="flex md:justify-between items-center overflow-x-auto md:overflow-visible no-scrollbar gap-6 md:gap-0 mb-6 md:mb-8 lg:mb-10 px-2">
          {["Cart", "Shipping", "Delivery", "Payment", "Summary"].map(
            (step, index) => (
              <div
                key={index}
                className="relative flex items-center text-sm md:text-base lg:text-lg font-medium text-gray-800 flex-shrink-0"
              >
                {/* Step Circle */}
                <div
                  className={`w-8 h-8 flex items-center justify-center rounded-full text-white font-bold 
          ${index < 5 ? "bg-black" : "bg-gray-300"}`}
                >
                  {index < 5 ? "✔" : index + 1}
                </div>

                {/* Step Name */}
                <p className="ml-3 whitespace-nowrap">{step}</p>

                {/* Connector Line */}
                {index < 6 && (
                  <div className="hidden sm:block absolute left-full ml-3 top-1/2 transform -translate-y-1/2 w-12 md:w-16 lg:w-20 border-b-4 border-gray-700"></div>
                )}
              </div>
            )
          )}
        </div>
      </div>
      <section className="w-full h-[268px] bg-black flex flex-col items-center justify-center text-center px-4">
        <h1 className="text-white text-2xl sm:text-3xl md:text-4xl font-bold mb-2">
          THANK YOU ! {profile?.nama || "User"}
        </h1>
        <p className="text-gray-300 text-sm sm:text-base md:text-lg">
          <div>
            {order ? (
              <div>
                <span className="font-semibold text-white">
                  Your order{" "}
                  <span style={{ color: "#CCAB5C" }}>#{orderid.slice(-7)}</span>
                </span>
              </div>
            ) : (
              <p>No orders found.</p>
            )}
          </div>
          is on process.
        </p>
      </section>

      <div className="grid grid-cols-1 md:grid-cols-10 gap-6 bg-gray-100 min-h-screen p-4 md:p-8">
        <div className="md:col-span-6 bg-white p-6 md:p-8 rounded-2xl shadow-lg overflow-hidden">
          <div className="bg-white p-5 md:p-6 rounded-lg border-b-2 border-gray-200">
            <h2 className="text-sm md:text-base font-semibold text-gray-800 text-center md:text-left">
              Your Order is on Process
            </h2>
            <span className="text-sm">
              We will review your order, and a confirmation email will be sent
              to{" "}
              <span className="font-bold">
                {profile?.email || "lorem.ipsum@gmail.com"}
              </span>{" "}
              if the order is confirmed.
            </span>
          </div>
          <div className="bg-white p-5 md:p-6 rounded-lg border-b-2 border-gray-200">
            <h2 className="text-sm md:text-base font-semibold text-gray-800 text-center md:text-left">
              Customer Details
            </h2>
            {/* <p className="text-center text-lg">Loading addresses...</p> */}

            {/* Address Cards in 2 columns on desktop, 1 column on mobile */}
            <div>
              {selectedAddress && (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="relative bg-white p-2 transition w-full">
                    <div className="mb-4">
                      <h3 className="text-lg font-bold">
                        <span className="text-sm text-gray-500">Recipient</span>
                      </h3>
                      <p className="text-base font-semibold">
                        {selectedAddress.namapenerima}
                      </p>
                      <p className="text-sm text-gray-600">
                        {selectedAddress.nomerteleponpenerima}
                      </p>
                    </div>
                  </div>

                  <div className="relative bg-white p-2 transition w-full">
                    <div className="mb-4">
                      <h3 className="text-lg font-bold">
                        <span className="text-sm text-gray-500">
                          Delivery Address
                        </span>
                      </h3>
                      <p className="text-base font-semibold">
                        {selectedAddress.alamat}
                      </p>
                      <p className="text-sm text-gray-700">
                        {selectedAddress.kotaataukelurahan}
                      </p>
                      <p className="text-sm text-gray-700">
                        {selectedAddress.provinsi} - {selectedAddress.kodePos}
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="md:col-span-4 bg-white p-6 md:p-8 rounded-2xl shadow-lg overflow-hidden">
          {/* Products Selected */}
          <div className="space-y-4">
            <h2 className="text-sm md:text-base font-semibold text-gray-800">
              Order Detail
            </h2>

            {orders.length === 0 ? (
              <p className="text-center text-gray-500">Your cart is empty.</p>
            ) : (
              orders.map((item) => {
                const product = item.produk; // ✅ from backend response
                const quantity = item.jumlah;
                const color = item.nama_warna;
                const hargaPerItem = parseFloat(item.harga_per_item) || 0;
                const discount = parseFloat(item.diskon) || 0;

                const priceAfterDiscount =
                  discount > 0
                    ? hargaPerItem - (hargaPerItem * discount) / 100
                    : hargaPerItem;

                const finalPrice = priceAfterDiscount * quantity;

                return (
                  <div
                    key={item.id}
                    className="bg-white p-4 rounded-lg border-b-2 border-gray-200"
                  >
                    <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
                      {/* Product Image */}
                      <div className="flex-shrink-0">
                        <img
                          src={item.image}
                          alt={item.nama_produk}
                          className="w-28 h-28 md:w-32 md:h-32 object-cover rounded-lg"
                        />
                      </div>

                      {/* Product Info */}
                      <div className="flex flex-col justify-between flex-1 w-full">
                        <h2 className="text-sm md:text-base font-semibold text-gray-800">
                          {item.nama_produk}
                        </h2>

                        {item.produk.preorder === "Y" && (
                          <div className="relative w-full text-start">
                            <div className="bg-white text-[#CCAB5C] py-1 font-semibold text-base md:text-lg flex items-center gap-2">
                              <img
                                src={Clock}
                                alt="Clock icon"
                                className="h-6 w-6"
                              />{" "}
                              Pre-Order
                            </div>
                          </div>
                        )}

                        <div className="flex flex-wrap mt-2 text-sm text-gray-600 gap-x-4">
                          <p>Quantity: {quantity}</p>
                          <p>Color: {color}</p>
                        </div>
                      </div>

                      {/* Price */}
                      <div className="flex flex-col items-end text-right">
                        <p className="text-sm md:text-base font-bold text-black">
                          {formatRupiah(finalPrice)}
                        </p>
                        {discount > 0 && (
                          <p className="text-sm text-gray-400 line-through">
                            {formatRupiah(hargaPerItem * quantity)}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })
            )}
          </div>

          {/* Cart Summary */}
          {orders.length > 0 && (
            <div className="mt-8 space-y-4">
              {/* Subtotal */}
              <div className="bg-white p-5 md:p-6 rounded-lg border-b-2 border-gray-200">
                <div className="flex justify-between items-center">
                  <span className="text-base font-semibold">Subtotal</span>
                  <span className="text-base font-bold text-gray-800">
                    {formatRupiah(parseFloat(totalPrice) || 0)}
                  </span>
                </div>
              </div>

              {/* Delivery */}
              <div className="bg-white p-5 md:p-6 rounded-lg border-b-2 border-gray-200">
                {selectedOption ? (
                  <div className="space-y-2">
                    <div className="flex justify-between items-center">
                      <span className="text-base font-semibold">
                        Cost Delivery
                      </span>
                      <span className="text-base font-bold text-gray-800">
                        {selectedOption?.shipping_cost &&
                        selectedOption.shipping_cost > 0
                          ? formatRupiah(selectedOption.shipping_cost)
                          : "By Courier"}
                      </span>
                    </div>

                    <div className="text-sm text-gray-700">
                      <p>
                        <span className="font-semibold">Shipping:</span>{" "}
                        {selectedOption.shipping_name}
                      </p>
                      <p>
                        <span className="font-semibold">Service:</span>{" "}
                        {selectedOption.service_name}
                      </p>
                      {/* <p>
                        <span className="font-semibold">Description:</span>{" "}
                        {selectedOption.description}
                      </p> */}
                      <p>
                        <span className="font-semibold">
                          Estimated Delivery:
                        </span>{" "}
                        {selectedOption.etd} Hari
                      </p>
                    </div>
                  </div>
                ) : (
                  <p className="text-sm text-gray-500">{setCourier}.</p>
                )}
              </div>

              {/* Total */}
              <div className="bg-white p-5 md:p-6 rounded-lg border-b-2 border-gray-200">
                <div className="flex justify-between items-center">
                  <span className="text-base font-semibold">Total</span>
                  <span className="text-xl font-bold text-black">
                    {formatRupiah(
                      (parseFloat(totalPrice) || 0) +
                        (selectedOption ? selectedOption.shipping_cost : 0)
                    )}
                  </span>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <Footer />
    </>
  );
};

export default PaymentPage;
